module.exports = __webpack_public_path__ + "img/comprehensive.adf3cb48.png";